export default {"src":"/_next/static/media/icon_chat_search.c0197b06.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};